export default "__VITE_PUBLIC_ASSET__4e53a1ad__"